import * as React from "react";

import { Radio, Upload, Button } from "antd";
import { Plus } from "lucide-react";
import { Icon } from "src/components/icons/Icon";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";

import ReportSettingAPI from "./ReportSettingAPI";
import LocationAPI from "src/admin/Organization/Location/LocationAPI";

import Form from "antd/es/form";

import { Validation } from "src/common/utils";
import pickListContext from "src/context/pickListContext";
import WhiteLabelingForm from "src/components/forms/WhiteLabelingForm";
import { AdminPermissions } from "src/common/Permissions";
import { Spinner } from "src/components/common";
import { toast } from "react-toastify";

interface IProps {
	history?: any;
	match?: any;
}

interface IState {
	iconLoading: boolean;
	loading: boolean;
	locations: LocationDTO[];
	reportSetting: ReportSettingDTO;
	fileList: File[];
	isButtonDisabled: boolean;
	fileUrl: string;
	logoUrlFromServer: string;
	isLoading: boolean;
}

class OrganizationReportSettings extends React.Component<IProps, IState> {
	public static contextType = pickListContext;
	public defaultReportSetting = {
		id: undefined,
		showLocation: false,
		showLogo: false,
		whiteLabel: false,
		showContactInfo: false,
		locationId: undefined,
		vitalsReplacementText: "",
		coreReplacementText: "",
		excelerateReplacementText: "",
		disclaimer: "",
		logoUrl: "",
	};

	public state: IState = {
		iconLoading: false,
		loading: false,
		locations: [],
		isButtonDisabled: false,
		reportSetting: this.defaultReportSetting,
		fileList: [],
		fileUrl: "",
		logoUrlFromServer: "",
		isLoading: true,
	};

	public _isMounted = true;

	public componentDidMount() {
		const { organizationId } = this.props.match.params;
		if (organizationId !== "0") {
			ReportSettingAPI.getReportSetting({ organizationId })
				.then((response) => {
					if (this._isMounted) {
						this.setState({
							reportSetting: response,
							fileUrl: response.logoUrl ? response.logoUrl : "",
							logoUrlFromServer: response.logoUrl || "",
						});
					}
				})
				.then(() => this.setState({ isLoading: false }));
		}

		LocationAPI.getOrganizationLocations(organizationId)
			.then((response) => {
				if (this._isMounted) {
					this.setState({ locations: response });
				}
			})
			.then(() => this.setState({ isLoading: false }));
	}

	public componentWillUnmount() {
		this._isMounted = false;
	}

	public render() {
		const { reportSetting, fileUrl } = this.state;
		const uploadButton = this.setUploadButton();
		const reportSettingImage = this.displayReportSettingLogoImage();

		const validReportSetting = {
			reportSettingShowLogo: Validation.validateIsActive(
				reportSetting.showLogo!
			),
			reportSettingWhiteLabel: Validation.validateIsActive(
				reportSetting.whiteLabel!
			),
			// reportSettingShowContactInfo: Validation.validateIsActive(reportSetting.showContactInfo!),
			// reportSettingLocation: Validation.validateIfANumberOrNumbers(reportSetting.locationId!),
			// reportSettingLocationSetting: Validation.validateIfANumberOrNumbers(reportSetting.locationSelectionId!),
		};

		const locationOptions = this.context.pickListItems
			.filter(
				(p: PickListItemResponseDTO) =>
					p.pickListTypeCode === "ReportSettingLocation"
			)
			.swapItems(0, 1);
		const useReportSettingOption = locationOptions.find(
			(p: PickListItemResponseDTO) => p.code === "UseReportSetting"
		)!;

		return this.state.isLoading !== false ? (
			<Spinner />
		) : (
			<div className="container-fluid">
				<Form>
					{/*
						<div className="form-group row">
							<div className="col-2">
								<label htmlFor="showContactInfo">Show contact info</label>
								<div>
									<Form.Item
										hasFeedback={true}
										validateStatus={validReportSetting.reportSettingShowContactInfo.validationStatus}
										help={validReportSetting.reportSettingShowContactInfo.message}
									>
										<AuthorizationWrapper type="disable" permissions={[AdminPermissions.EditOrganizationReportSetting]}>
											<Radio.Group
												id="showContactInfo"
												name="showContactInfo"
												value={this.state.reportSetting.showContactInfo!}
												onChange={this.onReportSettingChange}
											>
												{[{ label: 'Yes', value: true }, { label: 'No', value: false }].map((item, index) => {
													return <Radio key={index} value={item.value}>{item.label}</Radio>;
												})}
											</Radio.Group>
										</AuthorizationWrapper>
									</Form.Item>
								</div>
							</div>
							<div className="col-2">
								<label>Location display</label>
								<div>
									<Form.Item
										hasFeedback={true}
										validateStatus={validReportSetting.reportSettingLocationSetting.validationStatus}
										help={validReportSetting.reportSettingLocationSetting.message}
									>
										<AuthorizationWrapper type="disable" permissions={[AdminPermissions.EditOrganizationReportSetting]}>
											<Radio.Group
												id="locationSelectionId"
												name="locationSelectionId"
												value={this.state.reportSetting.locationSelectionId!}
												onChange={this.onReportSettingChange}
												className={'flex-column'}
											>
												{locationOptions.map((item: PickListItemResponseDTO, index: number) => {
													return <Radio key={index} value={item.id}>{item.description}</Radio>;
												})}
											</Radio.Group>
										</AuthorizationWrapper>
									</Form.Item>
								</div>
							</div>
							{reportSetting.locationSelectionId === useReportSettingOption.id &&
							<div className="col-3">
								<label>Locations</label>
								<div>
									<Form.Item
										hasFeedback={true}
										validateStatus={validReportSetting.reportSettingLocation.validationStatus}
										help={validReportSetting.reportSettingLocation.message}
									>
										<AuthorizationWrapper type="disable" permissions={[AdminPermissions.EditOrganizationReportSetting]}>
											<Select
												style={{ width: '100%' }}
												id="locations"
												value={
													this.state.locations
													.filter(location => location.id! === this.state.reportSetting.locationId)
													.map(foundVal => {
														return {
															key: foundVal.id,
															label: foundVal.name
														};
													})}
												labelInValue={true}
												onChange={this.setLocation}
											>
												{this.state.locations ? this.state.locations.filter(loc => loc.isActive).map(loc => {
													return <Select.Option key={loc.id!.toString()} value={loc.id!}>{loc.name!}</Select.Option>;
												}) : []}
											</Select>
										</AuthorizationWrapper>
									</Form.Item>
								</div>
							</div>
							}
						</div>
						*/}
					<div className="form-group row">
						<div className="col-2">
							<label>Show logo</label>
							<div>
								<Form.Item
									hasFeedback={true}
									validateStatus={
										validReportSetting.reportSettingShowLogo.validationStatus
									}
									help={validReportSetting.reportSettingShowLogo.message}
								>
									<AuthorizationWrapper
										type="disable"
										permissions={[
											AdminPermissions.EditOrganizationReportSetting,
										]}
									>
										<Radio.Group
											id="showLogo"
											name="showLogo"
											value={this.state.reportSetting.showLogo!}
											onChange={this.onReportSettingChange}
										>
											{[
												{ label: "Yes", value: true },
												{ label: "No", value: false },
											].map((item, index) => {
												return (
													<Radio key={index} value={item.value}>
														{item.label}
													</Radio>
												);
											})}
										</Radio.Group>
									</AuthorizationWrapper>
								</Form.Item>
							</div>
						</div>
						<div className="col-5">
							<label>Logo</label>
							<AuthorizationWrapper
								type="disable"
								permissions={[AdminPermissions.EditOrganizationReportSetting]}
							>
								<Upload
									name="organizationReportSettingLogo"
									listType="picture-card"
									accept="image/*"
									showUploadList={false}
									customRequest={(option: any) =>
										this.handleCustomUploadRequest(option)
									} // trick upload that an action ('url to post on') was provided
								>
									{fileUrl ? reportSettingImage : uploadButton}
								</Upload>
							</AuthorizationWrapper>
						</div>
					</div>
					<div className="row form-group">
						<div className="col-2">
							<label>White label</label>
							<div>
								<Form.Item
									hasFeedback={true}
									validateStatus={
										validReportSetting.reportSettingWhiteLabel.validationStatus
									}
									help={validReportSetting.reportSettingWhiteLabel.message}
								>
									<AuthorizationWrapper
										type="disable"
										permissions={[
											AdminPermissions.EditOrganizationReportSetting,
										]}
									>
										<Radio.Group
											id="white Label"
											name="whiteLabel"
											value={this.state.reportSetting.whiteLabel!}
											onChange={this.onReportSettingChange}
										>
											{[
												{ label: "Yes", value: true },
												{ label: "No", value: false },
											].map((item, index) => {
												return (
													<Radio key={index} value={item.value}>
														{item.label}
													</Radio>
												);
											})}
										</Radio.Group>
									</AuthorizationWrapper>
								</Form.Item>
							</div>
						</div>
					</div>
					{this.state.reportSetting.whiteLabel && (
						<WhiteLabelingForm
							reportSetting={reportSetting}
							onReportSettingChange={this.onReportSettingChange}
						/>
					)}
					<div className="row">
						<div className="col-5">
							<AuthorizationWrapper
								type="disable"
								permissions={[AdminPermissions.EditOrganizationReportSetting]}
							>
								<Button
									type="primary"
									htmlType="submit"
									disabled={
										!this.isValid(validReportSetting) ||
										this.state.isButtonDisabled
									}
									onClick={this.onReportSettingSubmit}
								>
									Save
								</Button>
							</AuthorizationWrapper>
						</div>
					</div>
				</Form>
			</div>
		);
	}

	private displayReportSettingLogoImage = () => {
		const { fileUrl } = this.state;
		if (fileUrl !== undefined) {
			return (
				<img src={fileUrl} alt="reportsetting logo" className="org-logo" />
			);
		}

		return null;
	};

	private setUploadButton = () => {
		return (
			<AuthorizationWrapper
				type="disable"
				permissions={[AdminPermissions.EditOrganizationReportSetting]}
			>
				<div>
					<Icon icon={Plus} />
					<div className="ant-upload-text">Upload</div>
				</div>
			</AuthorizationWrapper>
		);
	};

	private handleCustomUploadRequest = (options: any) => {
		const { reportSetting } = this.state;
		const { onSuccess, onError, file } = options;
		if (onError === true) {
			onError("Something went wrong");
			return;
		}

		setTimeout(() => {
			onSuccess(this.setReportSettingLogo(reportSetting, file));
		}, 0);
	};

	private setReportSettingLogo = (
		reportSetting: ReportSettingDTO,
		logoFile: File
	) => {
		const reportSettingWithLogoUrl = {
			...reportSetting,
			logoUrl: URL.createObjectURL(logoFile),
		};
		this.setState({
			fileList: [logoFile],
			fileUrl: URL.createObjectURL(logoFile),
			reportSetting: reportSettingWithLogoUrl,
		});
	};

	private reportSettingLogoFile = () => {
		return this.state.fileList[0];
	};

	private isValid = (validReportSetting: any) => {
		// const useReportSetting = this.context.pickListItems.find((p: PickListItemResponseDTO) => p.code === 'UseReportSetting');
		let validateValues: string[] = [];
		validateValues = Object.keys(validReportSetting).map(
			(key) => validReportSetting[key].validationStatus
		);
		const isValid = Validation.isValid(validateValues);
		return isValid;
	};

	private onReportSettingChange = (e: any) => {
		let value = e.target.value!;
		if (value === "true") {
			value = true;
		}
		if (value === "false") {
			value = false;
		}
		let name = e.target.name;
		if (e.target.type === "radio") {
			value = value;
		} else if (e.target.type === "checkbox") {
			if (e.target.data !== undefined) {
				// If there's data then it's a checkbox group
				if (e.target.data.singleSelect) {
					value = value;
				} else {
					// Don't split if single value
					if (value === "") {
						value = [];
					} else {
						value = value.split(",");
					}
				}
				name = e.target.data.name;
			} else {
				value = e.target.checked;
			}
		}
		const reportSetting = {
			...this.state.reportSetting,
			[name]: value,
		};
		/*
		if (e.target.name === 'locationSelectionId') {
			const useReportSetting = this.context.pickListItems.find((p: PickListItemResponseDTO) => p.code === 'UseReportSetting');
			if (reportSetting.locationSelectionId !== useReportSetting.id) {
				reportSetting.locationId = undefined;
			}
		}
		*/
		this.setState({ reportSetting, isButtonDisabled: false });
	};

	/*
	private setLocation = (value: any) => {
		const reportSetting = { ...this.state.reportSetting };
		reportSetting.locationId = value.key;
		this.setState({ reportSetting });
	}
	*/

	private submitReportSettingWithoutLogo = (
		organizationId: number,
		reportSetting: ReportSettingDTO
	) => {
		let toastSuccessMessage = "Successfully updated branding";
		const toastErrorMessage = "Something went wrong !";

		if (reportSetting.id === undefined) {
			toastSuccessMessage = "Succesfully created branding";
		}

		return ReportSettingAPI.updateReportSetting(organizationId, reportSetting)
			.then(() => toast.success(toastSuccessMessage))
			.catch(() => toast.error(toastErrorMessage));
	};

	private submitReportSettingWithLogo = (
		organizationId: number,
		reportSetting: ReportSettingDTO
	) => {
		const reportSettingLogoFile = this.reportSettingLogoFile();

		ReportSettingAPI.upsertReportSettingLogo(reportSettingLogoFile)
			.then((logoUrl) => {
				reportSetting.logoUrl = logoUrl;
				this.setState({ reportSetting });
			})
			.then(() => {
				let toastErrorMessage = "Error creating new organization branding";
				const toastSuccessMessage = "Updated organization branding!";

				if (reportSetting.id !== undefined) {
					toastErrorMessage = `Error updating organization branding!`;
				}

				ReportSettingAPI.updateReportSetting(organizationId, reportSetting)
					.then(() => toast.success(toastSuccessMessage))
					.catch(() => toast.error(toastErrorMessage));
			})
			.catch(() => toast.error("Error uploading logo"));
	};

	private onReportSettingSubmit = () => {
		const organizationId = +this.props.match.params.organizationId;
		const reportSetting = {
			...this.state.reportSetting,
			id: this.state.reportSetting.id ? this.state.reportSetting.id : undefined,
		};
		this.setState({ isButtonDisabled: true });
		if (
			reportSetting.logoUrl === undefined ||
			reportSetting.logoUrl === "" ||
			this.state.logoUrlFromServer === reportSetting.logoUrl
		) {
			return this.submitReportSettingWithoutLogo(organizationId, reportSetting);
		}

		return this.submitReportSettingWithLogo(organizationId, reportSetting);
	};
}
export default OrganizationReportSettings;
